<template>
  <div
    :class="['no-results', { 'no-results--small': small }]"
    :style="{ marginTop: `${marginTop}px`, marginBottom: `${marginBottom}px` }"
  >
    <img v-if="!small" src="@/assets/img/schedule-plug-icon.svg" alt="">
    <div class="no-results__title">{{ title }}</div>
    <div class="no-results__text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'AppNoResults',
  props: {
    title: {
      type: String,
      default: 'No Results',
    },
    text: {
      type: String,
      default: 'There’s nothing to display at the moment.',
    },
    small: {
      type: Boolean,
      default: false,
    },
    marginTop: Number,
    marginBottom: Number
  }
}
</script>

<style lang="sass" scoped>
.no-results
  display: flex
  justify-content: center
  align-items: center
  flex-direction: column
  width: 100%
  height: 158px
  gap: 10px
  border: 1px solid #e6e6e6
  background-color: #fcfcfc
  text-align: center

.no-results--small
  height: 90px

.no-results__title
  font-size: 13px
  font-weight: 600
  text-transform: uppercase

.no-results__text
  color: #7d7d7d
  font-size: 13px
  font-weight: 600
</style>